import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Resulttable } from '../Resulttable'
import { Route } from '../Route'
import { Regions } from '../Regions'
import { Header } from '../Header'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  properties = properties || {
    typ: 'tabelle', // tabelle / strecke / header / regionen
    start: 'Bhf 1',
    ende: 'Bhf 2',
    uebertitel: 'Die Beispiel-Strecke',
    prozent: '00%',
    color: 'grey',
    verspaetung: '0:00 min',
    fahrzeit: '0:00 min',
  }
  const typ = properties?.typ
  const start = properties?.start
  const end = properties?.ende
  const pretitle = properties?.uebertitel
  const percentage = properties?.prozent
  const color = properties?.color
  const delaytime = properties?.verspaetung
  const duration = properties?.fahrzeit

  return (
    <AppContainer className={globalClasses.join(' ')}>
      {typ === 'strecke' && (
        <TextWidth>
          <Route
            start={start}
            end={end}
            pretitle={pretitle}
            percentage={percentage}
            color={color}
            delaytime={delaytime}
            duration={duration}
            tenant={tenant}
            colorMode={colorMode}
          />
        </TextWidth>
      )}
      {typ === 'header' && (
        <Header
          title={'So viel Verspätung haben die Züge auf Ihrer Pendler-Strecke'}
          titleMobile={'So viel Verspätung haben die Pendler-Züge'}
          lead={
            'Wie pünktlich sind die SBB auf den wichtigsten Pendler-Verbindungen? Und gibt es regionale Unterschiede? Eine Datenauswertung.'
          }
          tenant={tenant}
          colorMode={colorMode}
        />
      )}
      {typ === 'regionen' && (
        <TextWidth>
          <Regions />
        </TextWidth>
      )}
      {typ !== 'strecke' && typ !== 'header' && typ !== 'regionen' && (
        <TextWidth>
          <Resulttable tenant={tenant} colorMode={colorMode} />
        </TextWidth>
      )}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
